import script from "./DescriptiveInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptiveInput.vue?vue&type=script&setup=true&lang=js"

import "./DescriptiveInput.vue?vue&type=style&index=0&id=f9b28fb0&lang=css"

const __exports__ = script;

export default __exports__